import { render, staticRenderFns } from "./RPQ.vue?vue&type=template&id=d275f840&scoped=true&"
import script from "./RPQ.vue?vue&type=script&lang=js&"
export * from "./RPQ.vue?vue&type=script&lang=js&"
import style0 from "./RPQ.vue?vue&type=style&index=0&id=d275f840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d275f840",
  null
  
)

export default component.exports